import { get, post, put, patch } from "../Config"

export function VerifyTwoFactor({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/account/verify-2fa`, params, data, lang })
}

export function ResendTwoFactor({ params = {}, data = {}, lang }) {
    return post({ url: `/v1/admin/account/resend-2fa`, params, data, lang })
}

export function GetTwoFactorData({ params = {}, lang }) {
  return get({ url: `/v1/admin/account/get-2fa`, params, lang })
}